import React, { useState } from "react";
import "./TestimonialSlider.css";

const slides = [
  {
    image: "/images/newimage2.webp",         // left side model image
    productImage: "/images/headerpopup3.webp", // product card image
    product: {
      brand: "MOKOSH",
      name: "Corrective eye cream",
      price: "From Rs. 2,800.00",
    },
    stars: 5,
    quote:
      "This face cream is a game-changer—my skin feels softer, looks brighter, and stays hydrated all day!",
    author: "Monica L.",
  },
  {
    image: "/images/newimage3.webp",           // left side model image
    productImage: "/images/headerpopup4.webp", // product card image
    product: {
      brand: "MOKOSH",
      name: "Nourishing face serum",
      price: "From Rs. 3,200.00",
    },
    stars: 5,
    quote:
      "Absolutely love this serum! My skin has never felt so smooth and radiant. Will definitely repurchase!",
    author: "Priya S.",
  },
];

const StarRating = ({ count }) => (
  <div className="ts-stars">
    {Array.from({ length: count }).map((_, i) => (
      <span key={i} className="ts-star">&#9733;</span>
    ))}
  </div>
);

const TestimonialSlider = () => {
  const [current, setCurrent] = useState(0);
  const [animClass, setAnimClass] = useState("ts-slide-in");

  const goTo = (index) => {
    if (index === current) return;

    setAnimClass("ts-slide-out");

    setTimeout(() => {
      setCurrent(index);
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          setAnimClass("ts-slide-in");
        });
      });
    }, 350);
  };

  const slide = slides[current];

  return (
    <section className="ts-section">
      <div className={`ts-wrapper ${animClass}`}>

        {/* Left: Model Image */}
        <div className="ts-image-col">
          <img
            src={slide.image}
            alt={`Slide ${current + 1}`}
            className="ts-image"
          />

          {/* Product Card — uses separate productImage */}
          <div className="ts-product-card">
            <div className="ts-product-img-wrap">
              <img
                src={slide.productImage}
                alt={slide.product.name}
                className="ts-product-img"
              />
            </div>

            <div className="ts-product-info">
              <span className="ts-product-brand">{slide.product.brand}</span>
              <span className="ts-product-name">{slide.product.name}</span>
              <span className="ts-product-price">{slide.product.price}</span>
            </div>

            <button className="ts-cart-btn" aria-label="Add to cart">
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z" />
                <line x1="3" y1="6" x2="21" y2="6" />
                <path d="M16 10a4 4 0 01-8 0" />
              </svg>
            </button>
          </div>
        </div>

        {/* Right: Testimonial */}
        <div className="ts-content-col">
          <StarRating count={slide.stars} />
          <blockquote className="ts-quote">
            &ldquo;{slide.quote}&rdquo;
          </blockquote>
          <p className="ts-author">— {slide.author}</p>
        </div>
      </div>

      {/* Dots */}
      <div className="ts-dots">
        {slides.map((_, i) => (
          <button
            key={i}
            className={`ts-dot ${i === current ? "ts-dot-active" : ""}`}
            onClick={() => goTo(i)}
            aria-label={`Go to slide ${i + 1}`}
          />
        ))}
      </div>
    </section>
  );
};

export default TestimonialSlider;